'use client';
import Typography from '@/components/shared/typography/typography.component';
import { ReactNode } from 'react';
import styles from './styles.module.scss';
import Image from 'next/image';
import colors from '@/theme/colors.module.scss';
import { IVariant } from '@/components/shared/typography/typography.types';

interface ComponentProps {
    children?: ReactNode;
}
const GridContainer = ({ children }: ComponentProps) => {
    return (
        <div className={styles.GridContainer}>
            <>{children}</>
        </div>
    );
};

interface GridItemInterface {
    variant: 'text' | 'text-with-icon';
    top?: boolean;
    bottom?: boolean;
    left?: boolean;
    right?: boolean;
    itemWidth?: number;
    cliclable?: boolean;
}
const border = `1px solid ${colors.gray200}`;

interface GridItemInterfaceWithChildren
    extends GridItemInterface,
        ComponentProps {
    onClick: () => void;
}

const GridItem = ({
    children,
    itemWidth,
    cliclable,
    variant,
    top,
    bottom,
    left,
    right,
    onClick,
}: GridItemInterfaceWithChildren) => {
    const customStyles: any = {};
    if (itemWidth) customStyles.width = `${itemWidth}%`;
    if (cliclable) customStyles.cursor = 'pointer';
    if (variant && variant == 'text-with-icon')
        customStyles.textAlign = 'center';
    if (top) customStyles.borderTop = border;
    if (bottom) customStyles.borderBottom = border;
    if (left) customStyles.borderLeft = border;
    if (right) customStyles.borderRight = border;
    return (
        <div className={styles.GridItem} style={customStyles} onClick={onClick}>
            <>{children}</>
        </div>
    );
};
interface TypographyInterfaceWithVairant extends ComponentProps {
    variant?: IVariant;
}

const GridItemMainText = ({
    children,
    variant,
}: TypographyInterfaceWithVairant) => {
    return (
        <Typography
            className={styles.GridItemMainText}
            variant={variant}
            component="h3"
        >
            <>{children}</>
        </Typography>
    );
};

const GridItemSecondaryText = ({
    children,
    variant,
}: TypographyInterfaceWithVairant) => {
    return (
        <Typography
            className={styles.GridItemSecondaryText}
            variant={variant}
            component="h3"
        >
            <>{children}</>
        </Typography>
    );
};

const GridItemIcon = ({ src, alt }: { src: string; alt: string }) => {
    return (
        <Image
            src={src}
            alt={alt || 'Car grid item icon'}
            width={32}
            height={32}
            style={{ marginBottom: '8px', display: 'inline-block' }}
        />
    );
};

const GridSectionFooter = ({ children }: ComponentProps) => {
    return (
        <div className={styles.GridSectionFooter}>
            <>{children}</>
        </div>
    );
};

export {
    GridContainer,
    GridItem,
    GridItemMainText,
    GridItemSecondaryText,
    GridItemIcon,
    GridSectionFooter,
};
